import mapIcon from '@disy/cadenza-icons/map.svg';
import $ from 'jquery';
import h from 'hyperscript';

import { Modal } from 'ui/dialog/modal/modal';

import { icon } from 'cadenza/utils/icon/icon';
import { on } from 'cadenza/utils/event-util';

import i18n from './location-finder-mobile-modal.properties';
import './location-finder-mobile-modal.css';

const COMPONENT_NAME = 'd-location-finder-mobile-modal';

export class LocationFinderMobileModal extends Modal {

  #components;

  constructor (components: HTMLElement[], clearSearch: () => void) {
    super({
      title: 'Location Finder',
      titleIcon: icon(mapIcon),
      submitButton: i18n('locationFinderMobileButton.title'),
      cancelButton: true
    });

    this.#components = components;
    on(this, 'cancel', () => {
      clearSearch();
    });
  }

  override connectedCallback () {
    super.connectedCallback();
    this.classList.add(COMPONENT_NAME);
    this.body.append(h('.d-location-finder-mobile-modal--input', ...this.#components));

    const inputSearchField = this.body.querySelector('.d-location-finder--search-field');
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore because jQuery
    $(inputSearchField).locationFinderAutocomplete('option', 'appendTo', '.d-location-finder-mobile-modal .d-modal--body');
  }

  override onSubmit () {
    this.close();
  }

}

customElements.define(COMPONENT_NAME, LocationFinderMobileModal);
